import React from "react"
import ReactDOM from "react-dom/client"
import Navbar from "./scripts/Navbar"
import Footer from "./scripts/Footer"
import FloatingActions from "./scripts/FloatingActions"
import ContactForm from "./scripts/ContactForm"

new Navbar()

// Footer React: se monta en el div de footer.php y recibe las URLs
// de WordPress vía data-props (JSON).
const footerMount = document.querySelector("#render-footer")
if (footerMount) {
  let props = {}
  try {
    props = JSON.parse(footerMount.dataset.props || "{}")
  } catch (e) {
    console.error("Footer props inválidos:", e)
  }
  ReactDOM.createRoot(footerMount).render(<Footer {...props} />)
}

// FAB flotante React: llamar · pedir (Toast) · correo.
const fabMount = document.querySelector("#render-fab")
if (fabMount) {
  let fabProps = {}
  try {
    fabProps = JSON.parse(fabMount.dataset.props || "{}")
  } catch (e) {
    console.error("FAB props inválidos:", e)
  }
  ReactDOM.createRoot(fabMount).render(<FloatingActions {...fabProps} />)
}

// ContactForm React: variante "capture" (home) y "full" (página Contact).
;["#render-contact-capture", "#render-contact-form"].forEach(sel => {
  const mount = document.querySelector(sel)
  if (!mount) return
  let props = {}
  try {
    props = JSON.parse(mount.dataset.props || "{}")
  } catch (e) {
    console.error("ContactForm props inválidos:", e)
  }
  ReactDOM.createRoot(mount).render(<ContactForm {...props} />)
})

// React también queda reservado para el componente interactivo
// "Build-Your-Way Chilaquiles" (Parte 4.5 del brief).